<div class="dashboard-header">
  <div class="dashboard-header-actions">
    <button mat-stroked-button class="dashboard-manage-button" [matMenuTriggerFor]="widgetsMenu">{{ manageDashboardLabel
      }}</button>
  </div>
</div>

<mat-menu #widgetsMenu="matMenu" class="dashboard-widgets-menu">
  <div class="widgets-menu-content" (click)="$event.stopPropagation()">
    <mat-checkbox *ngFor="let widget of availableWidgets" [checked]="isSelected(widget.id)"
      (click)="$event.stopPropagation()" (change)="toggleWidget(widget.id, $event.checked)">
      {{ widget.title }}
    </mat-checkbox>
  </div>
</mat-menu>

<div class="dashboard-motd">
  <app-message-of-the-day-widget></app-message-of-the-day-widget>
</div>

<div class="dashboard-grid">
  <div class="dashboard-column" *ngFor="let column of widgetColumns; let columnIndex = index" cdkDropList
    [id]="dropListIds[columnIndex]" [cdkDropListData]="column" [cdkDropListConnectedTo]="dropListIds"
    (cdkDropListDropped)="onDrop($event)">
    <div class="dashboard-widget" *ngFor="let widget of column; trackBy: trackByWidgetId" cdkDrag
      (cdkDragStarted)="onDragStarted($event)" (cdkDragEnded)="onDragEnded($event)"
      [cdkDragStartDelay]="dragStartDelay">
      <ng-template cdkDragPlaceholder>
        <div class="dashboard-widget-placeholder" [style.height.px]="activeDragPlaceholderHeight">
          <div class="dashboard-widget-placeholder-title">{{ getWidgetTitle(widget.id) }}</div>
        </div>
      </ng-template>
      <app-new-search-widget *ngIf="widget.id === 'newSearch'"></app-new-search-widget>
      <app-repeat-last-search-widget *ngIf="widget.id === 'repeatLastSearch'"></app-repeat-last-search-widget>
      <app-saved-searches-widget *ngIf="widget.id === 'savedSearches'"></app-saved-searches-widget>
      <app-recently-added-projects-widget
        *ngIf="widget.id === 'recentlyAddedProjects'"></app-recently-added-projects-widget>
      <app-recently-awarded-contracts-widget
        *ngIf="widget.id === 'recentlyAwardedContracts'"></app-recently-awarded-contracts-widget>
      <app-quick-find-project-widget *ngIf="widget.id === 'quickFindProject'"></app-quick-find-project-widget>
      <app-number-of-projects-chart-widget
        *ngIf="widget.id === 'numberOfProjectsChart'"></app-number-of-projects-chart-widget>
      <app-asset-analysis-chart-widget *ngIf="widget.id === 'asset-analysis-chart'"></app-asset-analysis-chart-widget>
      <app-recently-added-assets-widget
        *ngIf="widget.id === 'recently-added-assets'"></app-recently-added-assets-widget>
    </div>
  </div>
</div>